var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import tracking from "@irati-tracking/perks/perks";
import authentication from "@irati/auth";
import connect from "@irati/store/connect";
import Hr from "@irati/ui/src/Layout/Hr";
import { EARN, SPEND } from "@irati/deals/constants/categoryTypes";
import SearchAllByLocationCTA from "@irati-web/search/src/components/SearchAllByLocationCTA/SearchAllByLocationCTA";
import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray";
import CategoriesList from "./CategoriesList";
import Tags from "./Tags";
import ShowMore from "./ShowMore";
import EarnCategoryHeader from "./CategoryHeaders/EarnCategoryHeader";
import SpendCategoryHeader from "./CategoryHeaders/SpendCategoryHeader";
import { CategoriesWrapper, CategoryTitle } from "./styled";
var CategoriesTags = /** @class */ (function (_super) {
    __extends(CategoriesTags, _super);
    function CategoriesTags(props) {
        var _this = _super.call(this, props) || this;
        _this.handleShowMoreClick = function () {
            _this.setState({
                isShowingMore: !_this.state.isShowingMore
            });
        };
        _this.shouldDisplayShowMoreText = function () {
            _this.setState({
                displayShowMoreText: true
            });
        };
        _this.handleCategoryClick = function (category) {
            if (category.url && category.name !== _this.props.selectedCategory.name) {
                tracking.viewCategory(category.name);
            }
            _this.props.onChange(category);
        };
        _this.handleTagClick = function (tag) {
            tracking.viewTag(tag.name);
            var _a = _this.props, selectedCategory = _a.selectedCategory, selectedTags = _a.selectedTags, onChange = _a.onChange;
            // if UI shows none selected, actually all are, so just send array with this tag
            var allSelected = selectedCategory.tags.length === selectedTags.length;
            if (allSelected) {
                return onChange(selectedCategory, [tag]);
            }
            var tags = addOrRemoveFromArray(__spreadArrays(selectedTags), tag, function (a, b) { return a.uuid === b.uuid; });
            return onChange(selectedCategory, tags);
        };
        _this.getTopBanner = function () {
            var _a = _this.props, selectedCategory = _a.selectedCategory, isMobile = _a.isMobile;
            var isGeolocationActive = authentication.apps("platform.geoLocation");
            var isGeolocationRelated = selectedCategory.isGeolocationRelated, type = selectedCategory.type;
            if (type === SPEND) {
                return React.createElement(SpendCategoryHeader, null);
            }
            if (type === EARN) {
                return React.createElement(EarnCategoryHeader, null);
            }
            if (isGeolocationActive && isGeolocationRelated) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(SearchAllByLocationCTA, null),
                    isMobile && React.createElement(Hr, null)));
            }
            return null;
        };
        _this.state = {
            isShowingMore: false,
            displayShowMoreText: false
        };
        var selectedCategory = props.selectedCategory, selectedTags = props.selectedTags;
        if (selectedCategory.url) {
            // Don't track the ALL_CATEGORIES category
            tracking.viewCategory(selectedCategory.name);
        }
        selectedTags.forEach(function (tag) {
            tracking.viewTag(tag.name);
        });
        return _this;
    }
    CategoriesTags.prototype.render = function () {
        var _a = this.state, isShowingMore = _a.isShowingMore, displayShowMoreText = _a.displayShowMoreText;
        var _b = this.props, categories = _b.categories, selectedCategory = _b.selectedCategory;
        var tags = selectedCategory.tags.filter(function (tag) { return !!tag.filterable; }) || [];
        var selectedTags = selectedCategory.tags.length === this.props.selectedTags.length ? [] : this.props.selectedTags;
        return (React.createElement("div", null,
            React.createElement(CategoriesWrapper, null,
                React.createElement(CategoriesList, { isShowingMore: isShowingMore, displayShowMoreText: displayShowMoreText, shouldDisplayShowMoreText: this.shouldDisplayShowMoreText, data: categories, selected: selectedCategory, handleCategoryClick: this.handleCategoryClick }),
                React.createElement(ShowMore, { isShowingMore: isShowingMore, handleShowMoreClick: this.handleShowMoreClick, displayShowMoreText: displayShowMoreText }),
                (tags === null || tags === void 0 ? void 0 : tags.length) > 1 &&
                    React.createElement(React.Fragment, null,
                        React.createElement(CategoryTitle, { small: true, marginBottom: 1 },
                            React.createElement(FormattedMessage, { id: "perks.categories.subcategoryListHeader", values: { categoryName: selectedCategory.name } })),
                        React.createElement(Tags, { data: tags, selected: selectedTags, handleTagClick: this.handleTagClick }))),
            this.getTopBanner()));
    };
    return CategoriesTags;
}(React.Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({ isMobile: mq.lessThan.sm });
};
export default injectIntl(connect(mapStateToProps)(CategoriesTags));
